<template>
	
	<dialog v-if="mode === 'dialog'" :class="'sapphire-dialog modal-dialog ' + modalDialogSize" ref="sapphireDialog" :role="role" :aria-labelledby="dialogTitleId" :aria-describedby="dialogMessageId">
		<div class="modal-content">
			<div class="modal-header">
				<slot name="header" :close="close">
					<button type="button" class="close" aria-label="Close dialog" @click="close(false)" v-if="type === 'modal'">
						<span aria-hidden="true">&times;</span>
					</button>
					<h4 class="modal-title" :id="dialogTitleId">
						<template v-if="type === 'modal'">{{ modalTitle }}</template>
						<template v-else>{{ title }}</template>
					</h4>
				</slot>
			</div>
			<div class="modal-body" :id="dialogMessageId">
				<slot name="hint"></slot>
				<slot :close="close"></slot>
				<p v-if="type !== 'modal'">{{ message }}</p>
			</div>
			<div class="modal-footer">
				<slot name="footer" :close="close">
					<button type="button" class="btn btn-default" @click="close(false)" v-if="type === 'modal'">{{ closeText }}</button>
					
					<button type="button" class="btn btn-default" @click="close(false)" v-if="type === 'confirm'">{{cancelText}}</button>
					<button type="button" class="btn btn-primary" @click="close(true)" v-if="type !== 'modal'">{{okText}}</button>
				</slot>
			</div>
		</div>
	</dialog>

	<div v-else-if="mode === 'custom'" name="modal" :class="['modal-mask', {'modal-open': _show}]" v-show="_show">
		<div ref="sapphireDialog"
				 class="modal fade"
				 :class="{ 'in': _show }"
				 :style="openStyles"
				 tabindex="-1"
				 :role="role"
				 aria-labelledby="dialogTitleId"
				 :aria-describedby="dialogMessageId"
		>
			<div :class="'modal-dialog '+modalDialogSize" role="document" >
				<div class="modal-content" @click.stop>
					<div class="modal-header">
						<slot name="header" :close="close">
							<button type="button" class="close" aria-label="Close" @click="close">
								<span aria-hidden="true">&times;</span>
							</button>
							<h4 class="modal-title" :id="dialogTitleId">
								<template v-if="type === 'modal'">{{ modalTitle }}</template>
								<template v-else>{{ title }}</template>
							</h4>
						</slot>
					</div>
					<div class="modal-body" :id="dialogMessageId">
						<slot name="hint"></slot>
						<slot :close="close"
									:fields="fields"></slot>
					</div>
					<div class="modal-footer">
						<slot name="footer" :close="close">
							<button type="button" class="btn btn-default" @click="close">
								{{ closeText }}
							</button>
						</slot>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'sapphireDialog',
	props: {
		show: {
			type: Boolean,
			default: false
		},
		modalTitle: {
			type: String,
			default: ''
		},
		dialogSize: {
			type: String,
			default: null
		},
		enableClickOut: {
			type: Boolean,
			default: false
		},
		disableClickOut: {
			type: Boolean,
			default: false
		},
		enableFocusTrap: {
			type: Boolean,
			default: true
		},
		closeText: {
			type: String,
			default: 'Close'
		},
		mode: {
			type: String,
			default: 'dialog'
		}
	},
	data(){
		return {
			okText: 'Continue',
			cancelText: 'Cancel',
			message: '',
			title: 'Confirmation Needed',
			resolvePromise: null,
			rejectPromise: null,
			previouslyFocusedElement: null,
			type: '',
			dialogTitleId: '',
			dialogMessageId: '',
		};
	},
	computed: {
		modalDialogSize() {
			return this.dialogSize ? 'modal-'+this.dialogSize : '';
		},
		openStyles() {
			return this._show ? { 'display': 'block' } : {};
		},
		_show: {
			get() {
				return this.show;
			},
			set ( v ) {
				this.$emit('update:show', v);
			}
		},
		role(){
			return ['confirm', 'alert'].includes(this.type) ? 'alertdialog' : 'dialog';
		}
	},
	methods: {
		generateId(prefix = 'id') {
			return `${prefix}-${Math.random().toString(36).substr(2, 9)}`;
		},
		open(type, message, options={}){
			if( !!this.$refs.sapphireDialog && !this.$refs.sapphireDialog.open){
				this.previouslyFocusedElement = document.activeElement;

				if( !!type ){
					this.type = type;
					if( !!options.title ){
						this.title = options.title;
					}
					if( !!options.okText ){
						this.okText = options.okText;
					}
					if( !!options.cancelText ){
						this.cancelText = options.cancelText;
					}
					this.message = message;
				} else {
					this.type = 'modal';
				}

				this.$refs.sapphireDialog.showModal();
				//this.$refs.sapphireDialog.open = this._show;
				this.$emit('open');

				this.$nextTick(() => {
					this.$refs.sapphireDialog.querySelector('button').focus();
				});

				if (!!type) {
					return new Promise((resolve, reject) => {
						this.resolvePromise = resolve;
						this.rejectPromise = reject;
					});
				}
			}
		},
		// Intercept the close function to resolve or reject the promise chain
		close(isConfirmed = false){

			if( !!this.$refs.sapphireDialog && this.$refs.sapphireDialog.open ){
				this.$refs.sapphireDialog.close(false);
				//this.$refs.sapphireDialog.open = this._show;
				this.$emit('close');

				// Resolve or reject if triggered via programmatic plugin
				if (this.type !== 'modal') {
					if (isConfirmed) {
						this.resolvePromise(isConfirmed); // Triggers .then()
					} else {
						this.rejectPromise(isConfirmed);
					}
					// Reset programmatic state after closing
					this.reset();
				}
			}
		},
		reset(){
			this.isConfirmModal = false;
			this.isAlertModal = false;
			this.okText = 'Continue';
			this.cancelText = 'Cancel';
			this.message = '';
			this.title = 'Confirmation Needed';
			this.type = 'modal';
		},
		handleClickOut(e){
			console.log(e.target)
			console.log(this.$refs.sapphireDialog);
			if (this.enableClickOut && e.target === this.$refs.sapphireDialog) {
				this.close(false); // Registers as a rejection/dismissal
			}
		},
		handleKeyDown(e) {
			if( !this.enableFocusTrap ) {
				return;
			}

			// Get an updated list of focusable elements inside the modal
			const focusableSelectors = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

			const focusableElements = this.$refs.sapphireDialog.querySelectorAll(focusableSelectors);
			const firstElement = focusableElements[0];
			const lastElement = focusableElements[focusableElements.length - 1];

			// Rule 1: Handle the Escape key exit route (WCAG compliance)
			if (e.key === 'Escape' || e.keyCode === 27) {
				this.close(false);
				return;
			}

			// Rule 2: Handle the Tab key trap
			if (e.key === 'Tab' || e.keyCode === 9) {
				
				// Case A: Shift + Tab (Moving backwards)
				if (e.shiftKey) {
					if (document.activeElement === firstElement) {
						lastElement.focus(); // Loop backward to the last element
						e.preventDefault();
					}
				} 
				// Case B: Tab (Moving forwards)
				else {
					if (document.activeElement === lastElement) {
						firstElement.focus(); // Loop forward to the first element
						e.preventDefault();
					}
				}
			}
		}
	},
	watch: {
		_show: {
			handler(v){
				if( v ){ 
					this.open()
					this.$emit('open');
				} else {
					this.close(false);
					this.$emit('close');
				}
			}
		},
	},
	created(){
		this.dialogTitleId = this.generateId('dialog-title');
		this.dialogMessageId = this.generateId('dialog-message');
	},
	mounted(){
		if( !!this.$refs.sapphireDialog ){
			this.$refs.sapphireDialog.addEventListener( "cancel", this.close );
			this.$refs.sapphireDialog.addEventListener( "click", this.handleClickOut );
			this.$refs.sapphireDialog.addEventListener( "keydown", this.handleKeyDown);

			if( !this.$refs.sapphireDialog.showModal ){
				this.$refs.sapphireDialog.showModal = function() { this.open = true; };
			}
			if( !this.$refs.sapphireDialog.close ){
				this.$refs.sapphireDialog.close = function() { this.open = false; };
			}

			this.$refs.sapphireDialog.open = this._show;

		}
		if( this.mode === 'custom' ){
			document.addEventListener( 'keydown', e => {
				if(this.show && e.keyCode === 27) {
					this.close();
				}
			});
		}
	},
	beforeDestroy() {
		if( !!this.$refs.sapphireDialog ){
			this.$refs.sapphireDialog.removeEventListener( "cancel", this.close );
			this.$refs.sapphireDialog.removeEventListener( "click", this.handleClickOut );
			this.$refs.sapphireDialog.removeEventListener( "keydown", this.handleKeyDown );
		}
  },
}
</script>

<style scoped>
	.sapphire-dialog {
		padding: 0;
		border: none;
		background: none;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		margin: 0; /* Clears browser default auto margins */
	}
	.sapphire-dialog::backdrop {
		background-color: rgba(0, 0, 0, 0.5); 
	}
</style>